export default __webpack_public_path__ + "static/media/loader_gif.c322585d.gif";